import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "./App.jsx"
import { BrowserRouter as Router } from "react-router-dom"
// import { BrowserRouter as Router } from "@router" // TODO: to hide this framework on wappalyzer detection
import { Provider } from "react-redux"
import store from "./app/redux/store.js"
import { injectStore } from "./app/utils/axios.js"
injectStore(store)
import { HelmetProvider } from "react-helmet-async"

createRoot(document.getElementById("root")).render(
  <HelmetProvider>
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </HelmetProvider>
)
// <StrictMode>
//   <Router>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </Router>,
// </StrictMode>
